 
$(document).ready(function(){

/*************************** BANNER ANIMATION***************************/
  AOS.init({
    easing: 'ease-in-out-sine'
  });
/**************************Cutomized Product Counter Effect     ********************************/  
       var a = 0;
$(window).scroll(function() {
if (window.location.href.indexOf("custom-leather-jackets") == 0) {
  var oTop = $('#counter').offset().top - window.innerHeight;
  if (a == 0 && $(window).scrollTop() > oTop) {
    $('.counter-value').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({
        countNum: $this.text()
      }).animate({
          countNum: countTo
        },

        {

          duration: 2000,
          easing: 'swing',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
            //alert('finished');
          }

        });
    });
    a = 1;
  }
}
});
 
/**************************Size Chart     ********************************/   
  
    $('#boxes #size_cart_men .measure .size-chart-inches').click(function(){
      $(this).addClass('active');
      $('#boxes #size_cart_men .measure .size-chart-cm').removeClass('active');
      $('#boxes #size_cart_men .size-chart-inches-target').removeClass('hidden');
      $('#boxes #size_cart_men .size-chart-cm-target').addClass('hidden')
    });
    $('#boxes #size_cart_men .measure .size-chart-cm').click(function(){
      $(this).addClass('active');
      $('#boxes #size_cart_men .measure .size-chart-inches').removeClass('active');
      $('#boxes #size_cart_men .size-chart-inches-target').addClass('hidden');
      $('#boxes #size_cart_men .size-chart-cm-target').removeClass('hidden')
    });
    
     $('#women_boxes #size_cart_women .measure .size-chart-inches').click(function(){
      $(this).addClass('active');
      $('#women_boxes #size_cart_women .measure .size-chart-cm').removeClass('active');
      $('#women_boxes #size_cart_women .size-chart-inches-target').removeClass('hidden');
      $('#women_boxes #size_cart_women .size-chart-cm-target').addClass('hidden')
    });
    $('#women_boxes #size_cart_women .measure .size-chart-cm').click(function(){
      $(this).addClass('active');
      $('#women_boxes #size_cart_women .measure .size-chart-inches').removeClass('active');
      $('#women_boxes #size_cart_women .size-chart-inches-target').addClass('hidden');
      $('#women_boxes #size_cart_women .size-chart-cm-target').removeClass('hidden')
    });
    
     $(".sizechart-cst .men_tableCus.size-chart-inches-target td").hover(

    function(){
      console.log("HOVER 1");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".men_tableCus.size-chart-inches-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".men_tableCus.size-chart-inches-target tbody  tr").each(function(index){

        if(index < limit-1)

        {
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })


  $(".sizechart-cst .men_tableCus.size-chart-cm-target td").hover(

    function(){
      console.log("HOVER 2");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".men_tableCus.size-chart-cm-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".men_tableCus.size-chart-cm-target tbody  tr").each(function(index){

        if(index < limit-1)

        {
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".sizechart-cst .women_tableCus.size-chart-inches-target td").hover(

    function(){
      console.log("HOVER 3");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".women_tableCus.size-chart-inches-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".women_tableCus.size-chart-inches-target tbody  tr").each(function(index){

        if(index < limit-1)

        {
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".sizechart-cst .women_tableCus.size-chart-cm-target td").hover(

    function(){
      console.log("HOVER 4");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".women_tableCus.size-chart-cm-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".women_tableCus.size-chart-cm-target tbody  tr").each(function(index){

        if(index < limit-1)

        {
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })
  
  $(".MenTab").click(function(){
  $(this).addClass("active");
    $(".WomenTab").removeClass("active");
    $("#size_cart_men").css("display","block");
    $("#size_cart_women").css("display","none");
  })
   $(".WomenTab").click(function(){
  $(this).addClass("active");
    $(".MenTab").removeClass("active");
    $("#size_cart_men").css("display","none");
    $("#size_cart_women").css("display","block");
  })
   
    /************************************ LEATHER COLOR SLIDER  ********************************/
  $(window).resize(function() {
    if ( (screen.width < 760) || (screen.width == 760)) {

      var x =  $('.wrap_color_leather').children();

      for (i = 0; i < x.length ; i += 2) {
        x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
      }

      $('.wrap_color_leather').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        prevNext: true,
        infinite: false,
        arrows: true,
        autoplay: false,
        dots: true
      });

    }
    else{

      var x =  $('.wrap_color_leather').children();

      for (i = 0; i < x.length ; i += 2) {
        x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
      }

      $('.wrap_color_leather').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        prevNext: true,
        infinite: false,
        arrows: true,
        autoplay: false,
        dots: true,
        responsive: [{ 
          breakpoint: 500,
          settings: {
            arrows: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
          } 
        }]
      });

    }
  })
  if ($(window).width() <= 760) {

    var x =  $('.wrap_color_leather').children();

    for (i = 0; i < x.length ; i += 2) {
      x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
    }

    $('.wrap_color_leather').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      prevNext: true,
      autoplay: false,
      infinite: false,  
      arrows: true,
      dots: true
    });

  }
  else{

    var x =  $('.wrap_color_leather').children();

    for (i = 0; i < x.length ; i += 2) {
      x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
    }

    $('.wrap_color_leather').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      prevNext: true,
      infinite: false,  
      autoplay: false,
      arrows: true,
      dots: true,
      responsive: [{ 
        breakpoint: 500,
        settings: {
          arrows: true,
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 4,
        } 
      }]
    });

  }

  $(".leather_color").click(function(){
    $('.wrap_color_lining').slick('reinit');
    console.log("LINING");
  });

  /*********************************  LEATHER RADIO COLOR ***********************************/
  $('.main_container input[type="radio"]').click(function(){
    $('.main_container input[type="radio"]').each(function(){
      $(this).parent(".main_container").removeClass("leather_check");
    })
    $(this).parent(".main_container").addClass("leather_check");
  });

  /* LEATHER RADIO TYPE */
  $('.leatherType_radio input[type="radio"]').click(function(){
    if($(this).is(':checked')){
      $('.leatherType_radio input[type="radio"]').each(function(){
        $(this).parent(".leatherType_radio").removeClass("type_checked");
      })
      $(this).parent(".leatherType_radio").addClass("type_checked");
    }
  })

  /****************************** LINING COLOR SLIDER   ***********************************/
  $(window).resize(function() {
    if ( (screen.width < 760) || (screen.width == 760)) {
      $(function(){
        var x =  $('.wrap_color_lining').children();

        for (i = 0; i < x.length ; i += 2) {
          x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
        }

        $('.wrap_color_lining').slick({
          slidesToShow: 2,
          slidesToScroll: 2,
          prevNext: true,
          autoplay: false,
          infinite: false,  
          arrows: true,
          dots: true,
              arrows: true,
              infinite: false,
              slidesToShow: 2,
              slidesToScroll: 2,
        });
      });
    }
    else{
      $(function(){
        var x =  $('.wrap_color_lining').children();

        for (i = 0; i < x.length ; i += 2) {
          x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
        }

        $('.wrap_color_lining').slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          prevNext: true,
          infinite: false,  
          autoplay: false,
          arrows: true,
          dots: true,
          responsive: [{ 
            breakpoint: 500,
            settings: {
              arrows: true,
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 4,
            } 
          }]
        });
      }); 
    }
  })
  if ( (screen.width < 760) || (screen.width == 760)) {
    $(function(){
      var x =  $('.wrap_color_lining').children();

      for (i = 0; i < x.length ; i += 2) {
        x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
      }

      $('.wrap_color_lining').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        prevNext: true,
        infinite: false,  
        autoplay: false,
        arrows: true,
        dots: true,
            arrows: true,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 2,
      });
    });
  }
  else{
    $(function(){
      var x =  $('.wrap_color_lining').children();

      for (i = 0; i < x.length ; i += 2) {
        x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
      }

      $('.wrap_color_lining').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        prevNext: true,
        infinite: false,  
        arrows: true,
        dots: true,
        autoplay: false,
        responsive: [{ 
          breakpoint: 500,
          settings: {
            arrows: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
          } 
        }]
      });
    }); 
  }
  $(".lining_color").click(function(){
    $('.wrap_color_lining').slick('reinit');

  })

  /***********************   LINING COLOR RADIO *******************************/
  $('.main_container_new input[type="radio"]').click(function(){
    $('.main_container_new input[type="radio"]').each(function(){
      $(this).parent(".main_container_new").removeClass("lining_check");
    })
    $(this).parent(".main_container_new").addClass("lining_check");
  });

  /******************************** HARDWARE COLOR SLIDER   ***********************************/
  $(window).resize(function() {
    if ( (screen.width < 760) || (screen.width == 760)) {
      $(function(){
        var x =  $('.wrap_hardware_color').children();

        for (i = 0; i < x.length ; i += 2) {
          x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
        }

       $('.wrap_hardware_color').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        prevNext: true,
        infinite: false,  
         autoplay: false,
        arrows: true,
        dots: true,
        arrows: true,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 2,
      });
      });
    }
    else{
      $(function(){
        var x =  $('.wrap_hardware_color').children();

        for (i = 0; i < x.length ; i += 2) {
          x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
        }

        $('.wrap_hardware_color').slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          prevNext: true,
          infinite: false,  
          autoplay: false,
          arrows: true,
          dots: true,
          responsive: [{ 
            breakpoint: 500,
            settings: {
              arrows: true,
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 4,
            } 
          }]
        });
      }); 
    }
  })
  if ( (screen.width < 760) || (screen.width == 760)) {
    $(function(){
      var x =  $('.wrap_hardware_color').children();

      for (i = 0; i < x.length ; i += 2) {
        x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
      }

      $('.wrap_hardware_color').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        prevNext: true,
        autoplay: false,
        infinite: false,  
        arrows: true,
        dots: true,
        arrows: true,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 2,
      });
    });
  }
  else{
    $(function(){
      var x =  $('.wrap_hardware_color').children();

      for (i = 0; i < x.length ; i += 2) {
        x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
      }

      $('.wrap_hardware_color').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        prevNext: true,
        infinite: false,  
        autoplay: false,
        arrows: true,
        dots: true,
        responsive: [{ 
          breakpoint: 500,
          settings: {
            arrows: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
          } 
        }]
      });
    }); 
  }
  $(".hardware-color").click(function(){
    $('.wrap_hardware_color').slick('reinit');
  })

  /*****************************HARDWARE RADIO COLOR **************************************/
  $('.main_container_hardware input[type="radio"]').click(function(){
    $('.main_container_hardware input[type="radio"]').each(function(){
      $(this).parent(".main_container_hardware").removeClass("hardware_check");
    })
    $(this).parent(".main_container_hardware").addClass("hardware_check");
  });
  /**************************** STUD SLIDER************************************/  
  $(window).resize(function() {
    if ( (screen.width < 760) || (screen.width == 760)) {
      $(function(){
        var x =  $('.wrap_studs').children();

        for (i = 0; i < x.length ; i += 2) {
          x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
        }

        $('.wrap_studs').slick({
          slidesToShow: 2,
          slidesToScroll: 2,
          prevNext: true,
          autoplay: false,
          infinite: false,  
          arrows: true,
          dots: true,
              arrows: true,
              infinite: false,
              slidesToShow: 2,
              slidesToScroll: 2,
        });
      });
    }
    else{
      $(function(){
        var x =  $('.wrap_studs').children();

        for (i = 0; i < x.length ; i += 2) {
          x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
        }

        $('.wrap_studs').slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          prevNext: true,
          infinite: false,  
          autoplay: false,
          arrows: true,
          dots: true,
          responsive: [{ 
            breakpoint: 500,
            settings: {
              arrows: true,
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 4,
            } 
          }]
        });
      }); 
    }
  })
  if ( (screen.width < 760) || (screen.width == 760)) {
    $(function(){
      var x =  $('.wrap_studs').children();

      for (i = 0; i < x.length ; i += 2) {
        x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
      }

      $('.wrap_studs').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        prevNext: true,
        infinite: false,  
        autoplay: false,
        arrows: true,
        dots: true,
            arrows: true,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 2,
      });
    });
  }
  else{
    $(function(){
      var x =  $('.wrap_studs').children();

      for (i = 0; i < x.length ; i += 2) {
        x.slice(i,i+2).wrapAll('<div class="'+ i +'"></div>');
      }

      $('.wrap_studs').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        prevNext: true,
        infinite: false,  
        autoplay: false,
        arrows: true,
        dots: true,
        responsive: [{ 
          breakpoint: 500,
          settings: {
            arrows: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
          } 
        }]
      });
    }); 
  }
//   $(".studs").click(function(){
//     console.log("stud");
//     $('.wrap_studs').slick('reinit');
//   })

  /**************************************  STUDS CHECKBOX   *************************************/
  $('.main_container_stud input[type="checkbox"]').click(function(){
    var stud_value =  $(this).val();
    if(stud_value == "No Change"){
      $('.main_container_stud input[type="checkbox"]').each(function(){
        $(this).prop('checked', false);
        $(this).parent(".main_container_stud").removeClass("stud_check");
      })
      $(this).prop('checked', true);
      $(this).parent(".main_container_stud").addClass("stud_check");

    }
    else{

      $('.main_container_stud input[type="checkbox"]').each(function(){
        var first_stud = $(this).val();
        if(first_stud == "No Change"){
          $(this).prop('checked', false);
          $(this).parent(".main_container_stud").removeClass("stud_check");
        }
      })

    }
    if($(this).prop("checked") == true){
      $(this).parent(".main_container_stud").addClass("stud_check");
    }
    else if($(this).prop("checked") == false){
      $(this).parent(".main_container_stud").removeClass("stud_check");
    }
    var lnTH_STD = $('.stud_check').length;
    if(lnTH_STD == 3){
      $(".main_container_stud").addClass("stop_selection");
    }
    else{
      $(".main_container_stud").removeClass("stop_selection");
    }
  });
  $(".main_container_stud.whole_selection input").click(function(){
    var lTH_Std = $(".main_container_stud.whole_selection.stud_check").length;
    if(lTH_Std == 0 ){
      $(".main_container_stud.first_stud.default_selection input").prop('checked', true);
      $(".main_container_stud.first_stud.default_selection").addClass("stud_check");
    }
  })
  /***************************************  EMBROIDERY RADIO   ************************************/
  $('.embr_rd input[type="radio"]').click(function(){
    var em_radio = $(this).val();
    if(em_radio == "I want embroidery" ){
      $(".for_checked_embriod").show();
    }
    else{
      $(".for_checked_embriod").hide();
    }
    if($(this).is(':checked')){
      $('.embr_rd input[type="radio"]').each(function(){
        $(this).parent(".embr_rd").removeClass("embroid_checked");
      })
      $(this).parent(".embr_rd").addClass("embroid_checked");
    }
  })


  /************************************************** STEP 3   **************************************/
  $(".size_input input").click(function(){
    var size_val = $(this).val();

    if(size_val == "Customize Size" ){
      $(".dimensions").show();
      var men_value_1 = $('.men_dimenions_only .size_demensions.fill_all_val_1 input[type="text"]').val();
      var men_value_2 = $('.men_dimenions_only .size_demensions.fill_all_val_2 input[type="text"]').val();
      var women_value_1 = $('.women_dimenions_only .size_demensions.fill_all_val_1 input[type="text"]').val();
      var women_value_2 = $('.women_dimenions_only .size_demensions.fill_all_val_2 input[type="text"]').val();       

      if($(".dimen_check_1").is(':checked') || $(".dimen_check_2").is(':checked'))
      {}else{

        $(".size_demensions input").each(function(){
          $(this).attr("placeholder","in");
          $(this).prev("p").children("span").html("(in)");
        })

        $(".dimen_check_1").parent(".dimension_input").addClass("dimension_checked");
        $(".dimen_check_1").prop("checked", true);
      }

      var cheked_val = $(".gender_input.gender_checked input").val();
      if(cheked_val == "Men" ){
        $(".men_dimenions_only").show();
        $(".women_dimenions_only").hide();

      }else{
        $(".women_dimenions_only").show();
        $(".men_dimenions_only").hide();

      }
    }
    else{

      $(".dimensions").hide();
      $(".dimensions_fields").hide();
      $(".dimension_input input").each(function(){
        $(this).prop('checked', false);
        $(this).parent(".dimension_input").removeClass("dimension_checked");
      })
    }
    $(".size_input input").each(function(){
      $(this).parent(".size_input").removeClass("size_checked");
    })
    $(this).parent(".size_input").addClass("size_checked");
  });


  /***************************************GENDER CLICK *******************************/
  $(".gender_input input").click(function(){
    var custom_size = $(".size_input.size_checked input").val();
    var gender_val = $(this).val();

    if(gender_val == "Men" ){
      $(".men_pop").addClass("activated_size_popup");
      $(".women_pop").removeClass("activated_size_popup");
      if(custom_size == "Customize Size" ){
        $(".men_dimenions_only").show();
        $(".women_dimenions_only").hide();
        var men_val_1 =$('.men_dimenions_only .size_demensions.fill_all_val_1 input').val();
        var men_val_2 =$('.men_dimenions_only .size_demensions.fill_all_val_2 input').val();

      }

    }
    else{
      $(".women_pop").addClass("activated_size_popup");
      $(".men_pop").removeClass("activated_size_popup");
      if(custom_size == "Customize Size" ){
        $(".men_dimenions_only").hide();
        $(".women_dimenions_only").show();

      }

    }
    $(".gender_input input").each(function(){
      $(this).parent(".gender_input").removeClass("gender_checked");
    })
    $(this).parent(".gender_input").addClass("gender_checked");
  })

  /************************** DIMENSION UNIT *****************************/
  $(".dimension_input input").click(function(){
    var dimension_val =  $(this).val();
    if(dimension_val == "CM"){
      $(".size_demensions input").each(function(){
        $(this).attr("placeholder","cm");
        $(this).prev("p").children("span").html("(cm)");
      })
    }
    else{
      $(".size_demensions input").each(function(){
        $(this).attr("placeholder","in");
        $(this).prev("p").children("span").html("(in)");
      })
    }

    $(".dimension_input input").each(function(){
      $(this).parent(".dimension_input").removeClass("dimension_checked");
    })
    $(this).parent(".dimension_input").addClass("dimension_checked");
  })

  /******************** POPUP INFO ************************************/

  $( "#size_tab" ).tabs();
  $(".tabs_new li").click(function(){
    var data = $(this).children("a").attr("data-id");
    $(".tabs_new li").each(function(){
      $(this).removeClass("active");
    })
    $(this).addClass("active");
    $(".tab-content .tabs_number").each(function(){
      $(this).hide();
    })
    $('#' + data).show();
  })

  $(".tabs_new_women li").click(function(){
    var data = $(this).children("a").attr("data-id");
    $(".tabs_new_women li").each(function(){
      $(this).removeClass("active");
    })
    $(this).addClass("active");
    $(".tab-content .tabs_number_women").each(function(){
      $(this).hide();
    })
    $('#' + data).show();
  })
  /******************************** RELATED PRODUCTS SECTION  ***********************************/
  if ( (screen.width > 960) || (screen.width == 960)) {
    $('.menLeather').slick({
      dots: true,
      infinite: true,
      speed: 10,
      slidesToShow: 5,
      autoplay: false,
      slidesToScroll: 5,

    });
  }
  else if( (screen.width > 760) || (screen.width == 760)) {
    $('.menLeather').slick({
      dots: true,
      infinite: false,
      speed: 10,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 3,

    });
  }
  else if( (screen.width < 760)) {
    $('.menLeather').slick({
      dots: true,
      infinite: false,
      speed: 10,
      autoplay: false,
      slidesToShow: 2,
      slidesToScroll: 2,

    });
  }

  var butn = $(".menLeather .slick-dots li.slick-active").children("button").attr("aria-label");
  $(".men_page_detail .page_numbers").html(butn);


  $(".menLeather .slick-arrow").click(function(){
    var butn_click = $(".menLeather .slick-dots li.slick-active").children("button").attr("aria-label");
    $(".men_page_detail .page_numbers").html(butn_click);
    var butn_click_split = butn_click.split("of");
    var butn_click_first = butn_click_split[0];
    butn_click_first = parseInt(butn_click_first);
    if(butn_click_first > 1){
      $(".men_page_detail .start_num").show();
    }
    else{
      $(".men_page_detail .start_num").hide();
    }
  })
  $(".men_page_detail .start_num").click(function(){
    $('.menLeather').slick('slickGoTo', 1);
    $(".men_page_detail .start_num").hide();
    var butn_stop = $(".menLeather .slick-dots li.slick-active").children("button").attr("aria-label");
    $(".men_page_detail .page_numbers").html(butn_stop);
  })

  var butn = $(".menLeather .slick-dots li.slick-active").children("button").attr("aria-label");
  $(".men_page_detail .page_numbers").html(butn);

  if ( (screen.width > 960) || (screen.width == 960)) {
    $('.womenLeather').slick({
      dots: true,
      infinite: true,
      speed: 10,
      slidesToShow: 5,
      autoplay: false,
      slidesToScroll: 5,

    });
  }
  else if( (screen.width > 760) || (screen.width == 760)) {
    $('.womenLeather').slick({
      dots: true,
      infinite: false,
      speed: 10,
      slidesToShow: 3,
      autoplay: false,
      slidesToScroll: 3,

    });
  }
  else if( (screen.width < 760)) {
    $('.womenLeather').slick({
      dots: true,
      infinite: false,
      speed: 10,
      slidesToShow: 2,
      autoplay: false,
      slidesToScroll: 2,

    });
  }

  var women_butn = $(".womenLeather .slick-dots li.slick-active").children("button").attr("aria-label");
  $(".women_page_detail .page_numbers").html(women_butn);
  $(".womenLeather .slick-arrow").click(function(){
    var women_butn_click = $(".womenLeather .slick-dots li.slick-active").children("button").attr("aria-label");
    $(".women_page_detail .page_numbers").html(women_butn_click);
    var women_butn_click_split = women_butn_click.split("of");
    var women_butn_click_first = women_butn_click_split[0];
    women_butn_click_first = parseInt(women_butn_click_first);
    if(women_butn_click_first > 1){
      $(".women_page_detail .start_num").show();
    }
    else{
      $(".women_page_detail .start_num").hide();
    }
  })
  $(".women_page_detail .start_num").click(function(){
    $('.womenLeather').slick('slickGoTo', 1);
    $(".women_page_detail .start_num").hide();
    var women_butn_stop = $(".womenLeather .slick-dots li.slick-active").children("button").attr("aria-label");
    $(".women_page_detail .page_numbers").html(women_butn_stop);
  })
  
   /********************************* ADDITIONAL PRICE *****************************************/

  $('.embr_rd input[type="radio"]').click(function(){
    var checbox_val = $(this).val();
    var length =  $(".main_container_stud.stud_check").length;
    
    var check_stud =$('.main_container_stud.first_stud input[type="checkbox"]').prop("checked");
    console.log("checking" + check_stud);
    if(checbox_val == "I want embroidery" && check_stud == true && length > 0 ){
      $(".stu_price").hide();
      $(".both_price").hide();
      $(".one_price").hide();
      $(".emb_price").show();
    }
    else if(checbox_val == "" && length == 0){
      $(".stu_price").hide();
      $(".both_price").hide();
      $(".emb_price").hide();
      $(".one_price").show();  
    }
    else if (checbox_val == "I want embroidery" && length > 0 && check_stud == false){
      $(".stu_price").hide();
      $(".one_price").hide();
      $(".emb_price").hide();
      $(".both_price").show();    
    }
    else if(length > 0 && checbox_val == "" && check_stud == false){
      $(".both_price").hide();
      $(".one_price").hide();
      $(".emb_price").hide();
      $(".stu_price").show();      
    }
    else {
      $(".both_price").hide();
      $(".stu_price").hide();
      $(".emb_price").hide();
      $(".one_price").show();    
    }
  })

  $('.main_container_stud input[type="checkbox"]').click(function(){
    
    var checbox_val = $('.embr_rd.embroid_checked input[type="radio"]').val();
    
    var length =  $(".main_container_stud.stud_check").length;
    
    var check_stud =$('.main_container_stud.first_stud input[type="checkbox"]').prop("checked");
    console.log(check_stud);
    if(checbox_val == "I want embroidery" && check_stud == true && length > 0 ){
      $(".stu_price").hide();
      $(".both_price").hide();
      $(".one_price").hide();
      $(".emb_price").show();
    }
    else if(checbox_val == "" && length == 0){
      $(".stu_price").hide();
      $(".both_price").hide();
      $(".emb_price").hide();
      $(".one_price").show();  
    }
    else if (checbox_val == "I want embroidery" && length > 0 && check_stud == false){
      console.log("MAX PRICE");
      $(".stu_price").hide();
      $(".one_price").hide();
      $(".emb_price").hide();
      $(".both_price").show();    
    }
    else if(length > 0 && checbox_val == "" && check_stud == false){
       console.log("STUD ND PRODUCT");
      $(".both_price").hide();
      $(".one_price").hide();
      $(".emb_price").hide();
      $(".stu_price").show();      
    }
    else {
      $(".both_price").hide();
      $(".stu_price").hide();
      $(".emb_price").hide();
      $(".one_price").show();    
    }
  })

  
  /***************************** IMAGE PROGRESS BAR ***********************************************/
  $(".upload_1").change(function(){
    var image_size = (this.files[0].size);


    var ext =       $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 10240000){
      alert('Please upload the Maximum of 10MB image.');
      $(this).val('');
    }
    else{
      var file_data = $('.upload_1').prop('files')[0];
      var ne_get_1 = $('.upload_1').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/images/"+ne_get_1 ;
      var formData = new FormData($("#custom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              console.log("a"+percentComplete);
              $("#bar").show();

              $("#bar").text("("+percentComplete+"%)");
              $(".bar_wrapper_1").show();
              $(".msg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("bar").style.width=percentComplete+'%';
              //document.getElementById("bar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $(".msg_uploading_1").html("Image Uploaded");
                $("#custom_form_2").css("display","block");
                $(".lt_clr_img_1").html(ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
        }
      })
    }
  })

  $(".upload_2").change(function(){
    var image_size = (this.files[0].size);
    var ext =       $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 10240000){
      alert('Please upload the Maximum of 10MB image.');
      $(this).val('');
    }
    else{
      var file_data = $('.upload_2').prop('files')[0];
      var ne_get_2 = $('.upload_2').val().replace(/C:\\fakepath\\/i, '');
      ne_get_2 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/images/"+ne_get_2 ;
      var formData = new FormData($("#custom_form_2")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              console.log("a"+percentComplete);
              $("#bar_2").show();
              $("#bar_2").text("("+percentComplete+"%)");
              $(".bar_wrapper_2").show();
              $(".msg_uploading_2").html("Uploading.... Please wait.");
              document.getElementById("bar_2").style.width=percentComplete+'%';
              //document.getElementById("bar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $(".msg_uploading_2").html("Image Uploaded");
                $("#custom_form_3").css("display","block");
                $(".lt_clr_img_2").html(ne_get_2);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
        }
      })
    }

  })

  $(".upload_3").change(function(){
    var image_size = (this.files[0].size);
    var ext =       $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 10240000){
      alert('Please upload the Maximum of 10MB image.');
      $(this).val('');
    }
    else{
      var file_data = $('.upload_3').prop('files')[0];
      var ne_get_3 = $('.upload_3').val().replace(/C:\\fakepath\\/i, '');
      ne_get_3 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/images/"+ne_get_3 ;
      var formData = new FormData($("#custom_form_3")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              console.log("a"+percentComplete);
              $("#bar_3").show();
              $("#bar_3").text("("+percentComplete+"%)");
              $(".bar_wrapper_3").show();
              $(".msg_uploading_3").html("Uploading.... Please wait.");
              document.getElementById("bar_3").style.width=percentComplete+'%';
              //document.getElementById("bar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $(".msg_uploading_3").html("Image Uploaded");
                $("#custom_form_4").css("display","block");
                $(".lt_clr_img_3").html(ne_get_3);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
        }
      })
    }
  })

  $(".upload_4").change(function(){
    var image_size = (this.files[0].size);
    var ext =       $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 10240000){
      alert('Please upload the Maximum of 10MB image.');
      $(this).val('');
    }
    else{
      var file_data = $('.upload_4').prop('files')[0];
      var ne_get_4 = $('.upload_4').val().replace(/C:\\fakepath\\/i, '');
      ne_get_4 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/images/"+ne_get_4 ;
      var formData = new FormData($("#custom_form_4")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              console.log("a"+percentComplete);
              $("#bar_4").show();
              $("#bar_4").text("("+percentComplete+"%)");
              $(".bar_wrapper_4").show();
              $(".msg_uploading_4").html("Uploading.... Please wait.");
              document.getElementById("bar_4").style.width=percentComplete+'%';
              //document.getElementById("bar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $(".msg_uploading_4").html("Image Uploaded");
                $("#custom_form_5").css("display","block");
                $(".lt_clr_img_4").html(ne_get_4);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
        }
      })
    }
  })

  $(".upload_5").change(function(){
    var image_size = (this.files[0].size);
    var ext =       $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 10240000){
      alert('Please upload the Maximum of 10MB image.');
      $(this).val('');
    }
    else{
      var ne_get_5 = $('.upload_5').val().replace(/C:\\fakepath\\/i, '');
      ne_get_5 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/images/"+ne_get_5 ;
      var file_data = $('.upload_5').prop('files')[0];
      var formData = new FormData($("#custom_form_5")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              console.log("a"+percentComplete);
              $("#bar_5").show();
              $("#bar_5").text("("+percentComplete+"%)");
              $(".bar_wrapper_5").show();
              $(".msg_uploading_5").html("Uploading.... Please wait.");
              document.getElementById("bar_5").style.width=percentComplete+'%';
              //document.getElementById("bar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $(".msg_uploading_5").html("Image Uploaded");
                $(".lt_clr_img_5").html(ne_get_5);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
        }
      })
    }
  })
  $(".file_1").click(function(){  
    $(".upload_6").trigger("click");
  })
  $(".upload_6").change(function(){
    var image_size = (this.files[0].size);
    var ext =       $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 10240000){
      alert('Please upload the Maximum of 10MB image.');
      $(this).val('');
    }
    else{
      var name_get = $('.upload_6').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_6 = $('.upload_6').val().replace(/C:\\fakepath\\/i, '');
      ne_get_6 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/images/"+ne_get_6 ;
      var file_data = $('.upload_6').prop('files')[0];
      var formData = new FormData($("#custom_form_6")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              console.log("a"+percentComplete);
              $("#bar_6").show();
              $(".c_choosefile.file_1 p").text(name_get);
              $("#bar_6").text("("+percentComplete+"%)");
              $(".bar_wrapper_6").show();
              $(".msg_uploading_6").html("Uploading.... Please wait.");
              document.getElementById("bar_6").style.width=percentComplete+'%';
              //document.getElementById("bar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $(".msg_uploading_6").html("Image Uploaded");
                $(".lt_clr_img_6").html(ne_get_6);

              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
        }
      })
    }
  })  

  $(".file_2").click(function(){  

    $(".upload_7").trigger("click");
  })
  $(".upload_7").change(function(){
    var image_size = (this.files[0].size);
    var ext =       $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 10240000){
      alert('Please upload the Maximum of 10MB image.');
      $(this).val('');
    }
    else{
      var name_get = $('.upload_7').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_7 = $('.upload_7').val().replace(/C:\\fakepath\\/i, '');
      ne_get_7 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/images/"+ne_get_7 ;
      var file_data = $('.upload_7').prop('files')[0];
      var formData = new FormData($("#custom_form_7")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/leather/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              console.log("a"+percentComplete);
              $("#bar_7").show();
              $(".c_choosefile.file_2 p").html(name_get);
              $("#bar_7").text("("+percentComplete+"%)");
              $(".bar_wrapper_7").show();
              $(".msg_uploading_7").html("Uploading.... Please wait.");
              document.getElementById("bar_7").style.width=percentComplete+'%';
              //document.getElementById("bar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $(".msg_uploading_7").html("Image Uploaded");
                $(".lt_clr_img_7").html(ne_get_7);

              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
        }
      })
    }

  })
  
  /**************************** ADD TO CART CLICK  **************************************/

  $("#purchase_new").bind( "click", function(e) {

    e.preventDefault();
    var lt_img_1 = $(".lt_clr_img_1").html();
    $(".lt_in_1").val(lt_img_1);
    var lt_img_2 = $(".lt_clr_img_2").html();
    $(".lt_in_2").val(lt_img_2);
    var lt_img_3 = $(".lt_clr_img_3").html();
    $(".lt_in_3").val(lt_img_3);
    var lt_img_4 = $(".lt_clr_img_4").html();
    $(".lt_in_4").val(lt_img_1);
    var lt_img_5 = $(".lt_clr_img_5").html();
    $(".lt_in_5").val(lt_img_5);
    var lt_img_6 = $(".lt_clr_img_6").html();
    $(".lt_in_6").val(lt_img_6);
    var lt_img_7 = $(".lt_clr_img_7").html();
    $(".lt_in_7").val(lt_img_7);    
    var add_customized = $(".size_input.size_checked input").val();
    var gender_add = $(".gender_input.gender_checked").val();

    var value_stud_hidden = "";
    $('.main_container_stud.stud_check input[type="checkbox"]').each(function(){
      var new_value_stud_hidden = $(this).val();
      value_stud_hidden = new_value_stud_hidden +", "+ value_stud_hidden;
    });
     var checck = value_stud_hidden.indexOf("No Change");

      if(checck == -1){
       $(".stud_hidden_field").val(value_stud_hidden);
      }
    else{
     $(".stud_hidden_field").val();
    }
   
    var length =  $(".main_container_stud.stud_check").length;
    var embroidery =  $('.embr_rd.embroid_checked input[type="radio"]').val();
    var check_stud =$('.main_container_stud.first_stud input[type="checkbox"]').prop("checked");
    var custom_Opt = $(".size_input.size_checked input").val();
    var get_Gender = $(".gender_input.gender_checked input").val();
    var women_field_1 = $(".women_dimenions_only .size_demensions.fill_all_val_1 input").val();
    var women_field_2 = $(".women_dimenions_only .size_demensions.fill_all_val_2 input").val(); 
    var men_field_1 = $(".men_dimenions_only .size_demensions.fill_all_val_1 input").val();
    var men_field_2 = $(".men_dimenions_only .size_demensions.fill_all_val_2 input").val();  
    if(custom_Opt == "Customize Size"){
    
    }
    else{
    $(".men_dimenions_only input").val("");
    $(".dimensions_fields.women_dimenions_only input").val("");
    }
    if(custom_Opt == "Customize Size" && get_Gender == "Women" )
    {
      if(women_field_1 === '' && women_field_2 === "")
      {
        $(".women_error_1").css("display","block");
        $(".women_error_2").css("display","block");
      }

      else if (women_field_1 === '' && women_field_2 != "" )
      {
        $(".women_error_1").css("display","block");
        $(".women_error_2").css("display","none");       
      }

      else if (women_field_1 != '' && women_field_2 === "" )
      {
        $(".women_error_1").css("display","none");
        $(".women_error_2").css("display","block");      
      }
      else{
        $(".women_error_1").css("display","none");
        $(".women_error_2").css("display","none");  
        $("#purchase_new").addClass("loader_icon");
        $("#purchase_new").html('<i class="fa fa-circle-o-notch fa-spin" class="cst_load"></i>');
        if(length > 0 && embroidery == "" && check_stud == false){

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,	
            data: 'quantity=1&id=13632859439152',
            dataType: 'json',
            success: function(response){
              $("#add-to-cart-form").submit();
            }
          })
        }
        else if(embroidery == "I want embroidery" && length == 0)
        {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,
            data: 'quantity=1&id=13632862486576',
            dataType: 'json',
            success: function(response){
              $("#add-to-cart-form").submit();
            }
          })
        }
        else if (embroidery == "I want embroidery" && length > 0 && check_stud == false){
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,	
            data: 'quantity=1&id=13632859439152',
            dataType: 'json',
            success: function(response){
            }
          })
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,
            data: 'quantity=1&id=13632862486576',
            dataType: 'json',
            success: function(response){
              $("#add-to-cart-form").submit();
            }
          })
        }
        else if (embroidery == "I want embroidery" && length > 0 && check_stud == true){
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,
            data: 'quantity=1&id=13632862486576',
            dataType: 'json',
            success: function(response){
              $("#add-to-cart-form").submit();
            }
          })
        }
        else if (embroidery == "" && length == 0 ){
          $("#add-to-cart-form").submit();

        }
        else{
          $("#add-to-cart-form").submit();
        }
      }
    } 
    else if(custom_Opt == "Customize Size" && get_Gender == "Men" )
    {
      if(men_field_1 === '' && men_field_2 === "")
      {
        $(".men_error_1").css("display","block");
        $(".men_error_2").css("display","block");
      }

      else if (men_field_1 === '' && men_field_2 != "" )
      {
        $(".men_error_1").css("display","block");
        $(".men_error_2").css("display","none");      
      }

      else if (men_field_1 != '' && men_field_2 === "" )
      {
        $(".men_error_1").css("display","none");
        $(".men_error_2").css("display","block");       
      }
      else{
        $(".men_error_1").css("display","none");
        $(".men_error_2").css("display","none");  
        $("#purchase_new").addClass("loader_icon");
        $("#purchase_new").html('<i class="fa fa-circle-o-notch fa-spin" class="cst_load"></i>');
        if(length > 0 && embroidery == "" && check_stud == false){

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,	
            data: 'quantity=1&id=13632859439152',
            dataType: 'json',
            success: function(response){
              $("#add-to-cart-form").submit();
            }
          })
        }
        else if(embroidery == "I want embroidery" && length == 0)
        {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,
            data: 'quantity=1&id=13632862486576',
            dataType: 'json',
            success: function(response){
              $("#add-to-cart-form").submit();
            }
          })
        }
        else if (embroidery == "I want embroidery" && length > 0 && check_stud == false){
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,	
            data: 'quantity=1&id=13632859439152',
            dataType: 'json',
            success: function(response){
            }
          })
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,
            data: 'quantity=1&id=13632862486576',
            dataType: 'json',
            success: function(response){
              $("#add-to-cart-form").submit();
            }
          })
        }
        else if (embroidery == "I want embroidery" && length > 0 && check_stud == true){
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,
            data: 'quantity=1&id=13632862486576',
            dataType: 'json',
            success: function(response){
              $("#add-to-cart-form").submit();
            }
          })
        }
        else if (embroidery == "" && length == 0 ){
          $("#add-to-cart-form").submit();

        }
        else{
          $("#add-to-cart-form").submit();
        }
      }

    }
    else{
      $(".women_error_1").css("display","none");
      $(".women_error_2").css("display","none");       
      $(".men_error_1").css("display","none");
      $(".men_error_2").css("display","none");  
      $("#purchase_new").addClass("loader_icon");
      $("#purchase_new").html('<i class="fa fa-circle-o-notch fa-spin" class="cst_load"></i>');
      if(length > 0 && embroidery == "" && check_stud == false){

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async:false,	
          data: 'quantity=1&id=13632859439152',
          dataType: 'json',
          success: function(response){
            $("#purchase_new").addClass("loader_icon");
            $("#purchase_new").html('<i class="fa fa-circle-o-notch fa-spin" class="cst_load"></i>');         
            $("#add-to-cart-form").submit();
          }
        })
      }
      else if(embroidery == "I want embroidery" && length == 0)
      {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async:false,
          data: 'quantity=1&id=13632862486576',
          dataType: 'json',
          success: function(response){
            $("#purchase_new").addClass("loader_icon");
            $("#purchase_new").html('<i class="fa fa-circle-o-notch fa-spin" class="cst_load"></i>');         
            $("#add-to-cart-form").submit();
          }
        })
      }
      else if (embroidery == "I want embroidery" && length > 0 && check_stud == false){
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async:false,	
          data: 'quantity=1&id=13632859439152',
          dataType: 'json',
          success: function(response){
          }
        })
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async:false,
          data: 'quantity=1&id=13632862486576',
          dataType: 'json',
          success: function(response){
            $("#purchase_new").addClass("loader_icon");
            $("#purchase_new").html('<i class="fa fa-circle-o-notch fa-spin" class="cst_load"></i>');         
            $("#add-to-cart-form").submit();
          }
        })
      }
      else if (embroidery == "I want embroidery" && length > 0 && check_stud == true){
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async:false,
          data: 'quantity=1&id=13632862486576',
          dataType: 'json',
          success: function(response){
            $("#purchase_new").addClass("loader_icon");
            $("#purchase_new").html('<i class="fa fa-circle-o-notch fa-spin" class="cst_load"></i>');         
            $("#add-to-cart-form").submit();
          }
        })
      }
      else if (embroidery == "" && length == 0 ){
        $("#purchase_new").addClass("loader_icon");
        $("#purchase_new").html('<i class="fa fa-circle-o-notch fa-spin" class="cst_load"></i>');  
        $("#add-to-cart-form").submit();

      }
      else{
        $("#purchase_new").addClass("loader_icon");
        $("#purchase_new").html('<i class="fa fa-circle-o-notch fa-spin" class="cst_load"></i>');
        $("#add-to-cart-form").submit();

      }
    }

  })
  /********************************* ADDITIONAL PRICE *****************************************/

  $('.embr_rd input[type="radio"]').click(function(){
    var checbox_val = $(this).val();
    var length =  $(".main_container_stud.stud_check").length;
    
    var check_stud =$('.main_container_stud.first_stud input[type="checkbox"]').prop("checked");
    console.log("checking" + check_stud);
    if(checbox_val == "I want embroidery" && check_stud == true && length > 0 ){
      $(".stu_price").hide();
      $(".both_price").hide();
      $(".one_price").hide();
      $(".emb_price").show();
    }
    else if(checbox_val == "" && length == 0){
      $(".stu_price").hide();
      $(".both_price").hide();
      $(".emb_price").hide();
      $(".one_price").show();  
    }
    else if (checbox_val == "I want embroidery" && length > 0 && check_stud == false){
      $(".stu_price").hide();
      $(".one_price").hide();
      $(".emb_price").hide();
      $(".both_price").show();    
    }
    else if(length > 0 && checbox_val == "" && check_stud == false){
      $(".both_price").hide();
      $(".one_price").hide();
      $(".emb_price").hide();
      $(".stu_price").show();      
    }
    else {
      $(".both_price").hide();
      $(".stu_price").hide();
      $(".emb_price").hide();
      $(".one_price").show();    
    }
  })

  $('.main_container_stud input[type="checkbox"]').click(function(){
    
    var checbox_val = $('.embr_rd.embroid_checked input[type="radio"]').val();
    var length =  $(".main_container_stud.stud_check").length;
    
    var check_stud =$('.main_container_stud.first_stud input[type="checkbox"]').prop("checked");
    console.log(check_stud);
    if(checbox_val == "I want embroidery" && check_stud == true && length > 0 ){
      $(".stu_price").hide();
      $(".both_price").hide();
      $(".one_price").hide();
      $(".emb_price").show();
    }
    else if(checbox_val == "" && length == 0){
      $(".stu_price").hide();
      $(".both_price").hide();
      $(".emb_price").hide();
      $(".one_price").show();  
    }
    else if (checbox_val == "I want embroidery" && length > 0 && check_stud == false){
      console.log("MAX PRICE");
      $(".stu_price").hide();
      $(".one_price").hide();
      $(".emb_price").hide();
      $(".both_price").show();    
    }
    else if(length > 0 && checbox_val == "" && check_stud == false){
       console.log("STUD ND PRODUCT");
      $(".both_price").hide();
      $(".one_price").hide();
      $(".emb_price").hide();
      $(".stu_price").show();      
    }
    else {
      $(".both_price").hide();
      $(".stu_price").hide();
      $(".emb_price").hide();
      $(".one_price").show();    
    }
  })
  /******************************** CUSTOM PAGE ACCORDION ****************************/
   $( "#custom-page" ).accordion({collapsible: true, active: false });
  
  })